import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { useEffect } from 'react';
import { useBrowsePageStore } from './useBrowsePageStore';
import { useAnswerAuditInvitationMutation } from './useAnswerAuditInvitationMutation';

type DenyStatementFormType = {
  reason: string;
};

const DenyStatementModal = () => {
  const { t } = useTranslation();
  const browseViewStore = useBrowsePageStore();
  const isOpen = browseViewStore.modalState === 'deny-statement';

  const { mutate } = useAnswerAuditInvitationMutation();

  const form = useForm<DenyStatementFormType>({
    mode: 'onTouched',
    defaultValues: {
      reason: '',
    },
  });

  useEffect(() => {
    if (browseViewStore.modalState === 'hidden') {
      form.reset({
        reason: '',
      });
    }
  }, [browseViewStore.modalState, form]);

  const baseSubmit = (data: DenyStatementFormType) => {
    if (Object.keys(form.formState.dirtyFields).length === 0) {
      return;
    }

    mutate({
      id: browseViewStore.auditInvitation?.id as string,
      data: { choice: 'deny-statement', reason: data.reason },
    });
  };

  const handleClose = () => {
    form.reset({ reason: '' });
    browseViewStore.setModalState('hidden');
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth>
      <DialogTitle>{t('Are you sure?', { defaultValue: 'Are you sure?' })}</DialogTitle>
      <Box component="form" noValidate onSubmit={form.handleSubmit(baseSubmit)}>
        <DialogContent sx={{ pt: 0 }}>
          <Typography
            variant="body1"
            sx={(theme) => ({
              color: theme.palette.grey[700],
            })}
          >
            {t('Reason for denying statement ({{auditInvitationShowAs}}):', {
              defaultValue: 'Reason for denying statement ({{auditInvitationShowAs}}):',
              auditInvitationShowAs: browseViewStore.auditInvitation?.uId,
            })}
          </Typography>

          <Box sx={{ mt: '1rem' }}>
            <Controller
              control={form.control}
              name="reason"
              rules={{
                required: t('Reason is required.', {
                  defaultValue: 'Reason is required.',
                }).toString(),
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t('Reason', { defaultValue: 'Reason' })}
                  fullWidth
                  multiline
                  rows={4}
                  error={!!form.formState.errors.reason}
                  helperText={form.formState.errors.reason?.message?.toString()}
                />
              )}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit">Ok</Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default DenyStatementModal;
